import { currentLang, translate } from './i18n';

// Stored in English (orders and addresses keep the English name); shown translated with t().
export const EMIRATES = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Umm Al Quwain', 'Ras Al Khaimah', 'Fujairah'];

// Digits stay Western (1,234.50) in both languages, as is usual in the UAE.
const locale = () => (currentLang() === 'ar' ? 'ar-AE-u-nu-latn' : 'en-GB');

export function money(n, currency = 'AED') {
  return `${translate(currency)} ${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
}

export function dateTime(s) {
  return new Date(s).toLocaleString(locale(), { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function dateOnly(s) {
  return new Date(s).toLocaleDateString(locale(), { day: '2-digit', month: 'short', year: 'numeric' });
}

export const round2 = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;

export const usageLabel = (u) => (u === 'private' ? 'Private / Home' : 'Public / Commercial');

export const categoryHref = (key) => (key === 'installation' ? '/installation' : `/shop?category=${key}`);

export const tomorrow = () => new Date(Date.now() + 864e5).toISOString().slice(0, 10);

// Normalises a UAE mobile into wa.me format.
export const waLink = (phone, text) => {
  const digits = String(phone || '').replace(/\D/g, '').replace(/^0/, '971');
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
};

export function storageGet(key, fallback) {
  try { const v = localStorage.getItem(key); return v == null ? fallback : JSON.parse(v); } catch { return fallback; }
}
export function storageSet(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage unavailable */ }
}
